/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useContext } from 'react';
import { QueryProvider, QueryContext } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let SeoLinksImport;

/** *********************
 * Seo Links
 ********************** */
export const SeoLinksLoad = () => import(
  /* webpackChunkName: "seo-links" */
  '@thd-olt-component-react/seo-links')
  .then((module) => {
    const { SeoLinks } = module;

    SeoLinksImport = (props) => {
      const value = useContext(QueryContext);
      return (
        <QueryProvider cacheKey="seolinks-content" defaultVariables={value.defaultVariables.current}>
          <SeoLinks {...props} />
        </QueryProvider>
      );
    };
  });

export const SeoLinks = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/seo-links')).SeoLinks
  : (props) => <SeoLinksImport {...props} />;

export const SeoLinksModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/seo-links')).SeoLinks.dataModel
  : {};